import React, { useEffect, useState } from "react";
import Page from "../../component/Page";
import { getBranchList, getCatalogList } from "../setting/services/settingApi";
import api from "../../api/api";
import { saveAs } from "file-saver";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Menu,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { REPORT_CONFIG } from "./config";

const BrowserInput = function BrowserInput(props) {
  const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
  return (
    <TextField
      {...inputProps}
      ref={inputRef}
      value={
        value
          ? value.substring(0, value?.length - 6) +
            (parseInt(value?.substring(value?.length - 6)) + 543).toString()
          : null
      }
      {...other}
      variant="standard"
      fullWidth
      InputProps={{ disableUnderline: true }}
    />
  );
};

export default function ReportRiceSeedReserve() {
  const [branchs, setBranchs] = useState([]);
  const [Catalog, setCatalog] = useState([]);
  const [CatalogNo, setCatalogNo] = useState("");
  const [BranchNo, setBranchsNo] = useState("");
  const [Year, setYear] = useState("");
  const [Season, setSeason] = useState("");
  const [asOfDate, setAsOfDate] = useState(dayjs(new Date()));

  const [reports, setReports] = useState([]);
  const [sumValue, setSumValue] = useState();
  const [loadingDownload, setloadingDownload] = useState(false);
  const [loading, setloading] = useState(false);

  const { profile } = useSelector((state) => state.profile);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const seasons = ["ฝน", "แล้ง"];

  useEffect(() => {
    getBranchList(null, setBranchs);
    getCatalogList(null, setCatalog);
  }, []);

  function calculateSum() {
    const sumValue = { Qty: 0 };
    for (const row of reports) {
      sumValue.Qty += +row.Qty;
    }
    setSumValue(sumValue);
  }
  useEffect(() => {
    calculateSum();
  }, [reports]);

  async function getRiceSeedReserveReport(body, mode, format) {
    const url = `${REPORT_CONFIG.requests.riceSeedReserveReport.url}/${mode}`;

    let params = {};
    if (body.branchNo && body.branchNo !== "-")
      params = { ...params, branchNo: body.branchNo };
    if (body.catalogNo && body.catalogNo !== "-")
      params = { ...params, catalogNo: body.catalogNo };
    if (body.year) params = { ...params, year: body.year };
    if (body.season && body.season !== "-")
      params = { ...params, season: body.season };
    if (body.asOfDate) params = { ...params, asOfDate: body.asOfDate };
    if (format) params = { ...params, format: format };

    if (mode === "file") {
      setloadingDownload(true);
      const res = await api.get(url, {
        params: params,
        responseType: "arraybuffer",
      });
      const data = res.data;
      if (format) {
        const blob = new Blob([data], { type: "application/pdf" });
        saveAs(blob, "รายงานสำรองเมล็ดพันธุ์ข้าว");
      } else {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "รายงานสำรองเมล็ดพันธุ์ข้าว");
      }
      setloadingDownload(false);
    } else {
      setloading(true);
      const res = await api.get(url, { params: params });
      const data = res.data.result;
      setReports(data);
      setloading(false);
    }
  }

  function buildBody() {
    return {
      branchNo: BranchNo || undefined,
      catalogNo: CatalogNo || undefined,
      year: Year || undefined,
      season: Season || undefined,
      asOfDate: asOfDate ? dayjs(asOfDate).format("YYYY-MM-DD") : undefined,
    };
  }

  async function LoadReport() {
    getRiceSeedReserveReport(buildBody(), "data");
  }

  return (
    <div style={{ padding: "10px 30px" }}>
      <Page>
        <div class="container-fluid p-0">
          <form>
            <div class="row  no-gutters">
              <div class="col-12 col-lg-2">
                <div class="row no-gutters">
                  <div class="col-12 header-row border-1 ">ตัวกรอง</div>
                </div>
                <div class="row no-gutters p-2 border-1">
                  {profile?.BranchNo?.BranchNo === "00" && (
                    <div class="col-12">
                      <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                      <Box
                        className="backgroundField"
                        sx={{ marginBottom: "10px" }}
                      >
                        <FormControl variant="standard" fullWidth>
                          <Select
                            value={BranchNo || "-"}
                            onChange={(e) => setBranchsNo(e.target.value)}
                            disableUnderline
                          >
                            <MenuItem value="-">-</MenuItem>
                            {branchs?.map((x) => (
                              <MenuItem value={x?.BranchNo}>
                                {x?.BranchName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </div>
                  )}

                  <div class="col-12">
                    <label class="labelInput">พันธุ์ข้าว</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <FormControl variant="standard" fullWidth>
                        <Select
                          value={CatalogNo || "-"}
                          onChange={(e) => setCatalogNo(e.target.value)}
                          disableUnderline
                        >
                          <MenuItem value="-">-</MenuItem>
                          {Catalog?.map((x) => (
                            <MenuItem value={x?.CatalogNo}>
                              {x?.CatalogName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </div>

                  <div class="col-12">
                    <label class="labelInput">ฤดู</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <FormControl variant="standard" fullWidth>
                        <Select
                          value={Season || "-"}
                          onChange={(e) => setSeason(e.target.value)}
                          disableUnderline
                        >
                          <MenuItem value="-">-</MenuItem>
                          {seasons?.map((x) => (
                            <MenuItem value={x}>{x}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </div>

                  <div class="col-12">
                    <label class="labelInput">ปี (พ.ศ.)</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <TextField
                        variant="standard"
                        fullWidth
                        value={Year}
                        onChange={(e) => setYear(e.target.value)}
                        InputProps={{ disableUnderline: true }}
                      />
                    </Box>
                  </div>

                  <div class="col-12">
                    <label class="labelInput">คำนวน ณ วันที่</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "20px", borderRadius: "25px" }}
                    >
                      <MobileDatePicker
                        dayOfWeekFormatter={(day) => `${day}`}
                        value={asOfDate}
                        onChange={(e) => setAsOfDate(e)}
                        slotProps={{
                          textField: {
                            variant: "standard",
                            fullWidth: true,
                            InputProps: { disableUnderline: true },
                            value: asOfDate,
                          },
                        }}
                        slots={{ textField: BrowserInput }}
                      />
                    </Box>
                  </div>

                  <div class="col-12">
                    <Button
                      onClick={LoadReport}
                      disabled={loading ? true : false}
                      variant="contained"
                      className="ButtomSearch"
                    >
                      {loading ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ค้นหา"
                      )}{" "}
                    </Button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <div class="row no-gutters">
                  <div class="col-12 d-flex justify-content-between header-row border-1 ">
                    <div>รายงานสำรองเมล็ดพันธุ์ข้าว</div>
                    <Button
                      variant="contained"
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      disabled={loadingDownload ? true : false}
                      onClick={handleClick}
                    >
                      {loadingDownload ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ดาวน์โหลด"
                      )}
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                      PaperProps={{
                        style: {
                          width: 100,
                        },
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          getRiceSeedReserveReport(buildBody(), "file");
                          handleClose();
                        }}
                      >
                        Excel
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          getRiceSeedReserveReport(buildBody(), "file", "pdf");
                          handleClose();
                        }}
                      >
                        Pdf
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
                <div class="row no-gutters border-1 pt-3">
                  <div class="report col-12">
                    <div class="table-responsive-sm" style={{ height: "auto" }}>
                      <table class="table table-bordered table-sm table-hover">
                        <thead class="sticky-thead">
                          <tr>
                            <th scope="col">ศูนย์ที่สำรอง</th>
                            <th scope="col">ใช้ของ</th>
                            <th scope="col">ชื่อโครงการ/ชื่อลูกค้า</th>
                            <th scope="col">ตำบล</th>
                            <th scope="col">อำเภอ</th>
                            <th scope="col">จังหวัด</th>
                            <th scope="col">ชนิดพันธุ์</th>
                            <th scope="col">พันธุ์ข้าว</th>
                            <th scope="col">ชั้นพันธุ์</th>
                            <th scope="col">ฤดู</th>
                            <th scope="col">ปี</th>
                            <th scope="col">ปริมาณ (กิโลกรัม)</th>
                            <th scope="col">สถานะ</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reports?.map((report, i) => (
                            <tr class="cp">
                              <td class="text-center">
                                {report?.HeadBranchName || "-"}
                              </td>
                              <td class="text-center">
                                {report?.DetailBranchName || "-"}
                              </td>
                              <td class="text-center">
                                {report?.ProjectName || "-"}
                              </td>
                              <td class="text-center">
                                {report?.SubDistrict || "-"}
                              </td>
                              <td class="text-center">
                                {report?.District || "-"}
                              </td>
                              <td class="text-center">
                                {report?.Province || "-"}
                              </td>
                              <td class="text-center">
                                {report?.SeedType || "-"}
                              </td>
                              <td class="text-center">
                                {report?.RiceVariety || "-"}
                              </td>
                              <td class="text-center">
                                {report?.SeedClass || "-"}
                              </td>
                              <td class="text-center">
                                {report?.Season || "-"}
                              </td>
                              <td class="text-center">{report?.Year || "-"}</td>
                              <td class="text-center">
                                {report?.Qty ? report?.Qty.toLocaleString() : "0"}
                              </td>
                              <td class="text-center">
                                {report?.Status || "-"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <thead class="sticky-tfooter">
                          <tr>
                            <th scope="col" colspan="11">
                              รวม
                            </th>
                            <th scope="col">
                              {sumValue?.Qty?.toLocaleString()}
                            </th>
                            <th scope="col"></th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </div>
                </div>
                {reports.length === 0 && (
                  <div class="row">
                    <div class="col-12">
                      <div class="not-found">ไม่พบข้อมูล</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </Page>
    </div>
  );
}
